import { useTranslation } from "react-i18next";
import ilustracao from "../../../assets/frei_andre_thevet.jpg";

export default function HistoriaCastanha() {
  const { t } = useTranslation();

  return (
    <section id="historia-castanha-section" className="section_inicial">
      <h1>{t("castanha.historia.titulo")}</h1>
      <p
        dangerouslySetInnerHTML={{
          __html: t("castanha.historia.descricao.p1.p1-1")
        }}
      />
      <p>{t("castanha.historia.descricao.p1.p1-2")}</p>
      <p
        dangerouslySetInnerHTML={{
          __html: t("castanha.historia.descricao.p1.p1-3")
        }}
      />
      <p
        dangerouslySetInnerHTML={{
          __html: t("castanha.historia.descricao.p1.p1-4")
        }}
      />
      <p>{t("castanha.historia.descricao.p1.p1-5")}</p>
      <p>{t("castanha.historia.descricao.p1.p1-6")}</p>
      <div className="ilustracao-container">
        <p>
          {t("castanha.historia.descricao.p2.p2-1")}
          <br />
          {t("castanha.historia.descricao.p2.p2-2")}
          <br />
          <br />
          {t("castanha.historia.descricao.p2.p2-3")}
          <br />
          <br />
          {t("castanha.historia.descricao.p2.p2-4")}
        </p>
        <div className="ilustracao">
          <img src={ilustracao} alt="Ilustração de Frei André Thevet" />
          <p className="comentario">
            {t("castanha.historia.descricao.p2.p2-5")}
          </p>
        </div>
      </div>
    </section>
  );
}
